import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TenantItemDto } from '@artemis-software/wr-api';
import { Tracked } from '@/utils/signals/tracked';
import { loader } from '@/utils/signals/loader';

@Component({
  standalone: false,
  selector: 'wr-tenant-popover',
  templateUrl: './tenant-popover.component.html',
  styleUrls: ['./tenant-popover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TenantPopoverComponent {
  readonly router = inject(Router);

  @Input()
  @Tracked()
  tenant?: TenantItemDto;

  @Input()
  @Tracked()
  disableLink = false;

  loading = loader();

  navigateToDetail() {
    this.router.navigate(['tenant', this.tenant!.id]);

  }
}
